import { Network } from '@/lib/config/types';
import { configService } from '@/services/config/config.service';
import { BalancerSDK } from '@xclabs/balancer-sdk';
import { ref } from 'vue';
// import { isTestMode } from '@/plugins/modes';

const COINGECKO_API_KEY = import.meta.env.VITE_COINGECKO_API_KEY ?? '';

const coingeckoConfig =
  COINGECKO_API_KEY && COINGECKO_API_KEY !== ''
    ? {
        isDemoApiKey: false,
        coingeckoApiKey: COINGECKO_API_KEY,
      }
    : undefined;

export const balancer = new BalancerSDK({
  network: configService.network.chainId as Network,
  rpcUrl: configService.rpc,
  customSubgraphUrl: configService.network.subgraph,
  coingecko: coingeckoConfig,
  burrbearApiUrl: `${configService.env.API_URL}/graphql`,
});

export const hasFetchedPoolsForSor = ref(false);

export async function fetchPoolsForSor() {
  if (hasFetchedPoolsForSor.value) return;

  console.time('fetchPoolsForSor');
  await balancer.swaps.fetchPools();
  hasFetchedPoolsForSor.value = true;
  console.timeEnd('fetchPoolsForSor');
}

// if (!isTestMode()) fetchPoolsForSor();
